import { Dtos, IndividualContactId, SuretyAccountId } from "@inrev/common";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { accountIndividualsQueryKey, accountQueryKey } from "../account.keys";

export const useAdminUpsertIndividualContact = (
	accountId: SuretyAccountId,
	individualContactId?: IndividualContactId,
) => {
	const queryClient = useQueryClient();
	const { post, put } = useRequest();

	const mutation = useMutation({
		mutationFn: async (data: Dtos.Admin.IndividualContact.Create.Request) => {
			if (individualContactId) {
				await put(
					`/v2/admin/surety/accounts/${accountId}/individuals/${individualContactId}`,
					data,
					"none",
				);
			} else {
				await post(`/v2/admin/surety/accounts/${accountId}/individuals`, data, "none");
			}
		},
		onSuccess: async () => {
			await Promise.all([
				queryClient.invalidateQueries({ queryKey: accountQueryKey(accountId) }),
				queryClient.invalidateQueries({ queryKey: accountIndividualsQueryKey(accountId) }),
			]);
		},
	});

	return {
		upsertIndividualContact: mutation.mutate,
		upsertIndividualContactError: mutation.error,
		upsertIndividualContactIsLoading: mutation.isPending,
		upsertIndividualContactSuccess: mutation.isSuccess,
	};
};
